import { defineMessages } from 'react-intl';

export default defineMessages({
    removeLocationTitle:{
        id: 'quoteandbind.common.views.locations.RemoveLocationTitle',
        defaultMessage: 'Remove location details?'
    },
    removeLocationDescription:{
        id: 'quoteandbind.common.views.locations.RemoveLocationDescription',
        defaultMessage: 'Are you sure that you want to delete this Location Details?'
    },
    setPrimaryLocation:{
        id:'quoteandbind.common.views.locations.setPrimaryLocation',
        defaultMessage: 'Set Primary Location'
    },
    setOnePrimaryLocation:{
        id:'quoteandbind.common.views.locations.setOnePrimaryLocation',
        defaultMessage:'There must be at least one Primary Location selected'
    },
    error:{
        id:'quoteandbind.common.views.locations.Error',
        defaultMessage:'Error'
    },
    ok:{
        id:'quoteandbind.common.views.locations.ok',
        defaultMessage:'Ok'
    },
    isPrimaryLocation:{
        id: 'quoteandbind.common.views.locations.isPrimaryLocation',
        defaultMessage: 'Primary Location'
    },
    locationCode: {
        id: 'quoteandbind.common.views.locations.Location Code',
        defaultMessage: 'Location Code'
    },
    locationName: {
        id: 'quoteandbind.common.views.locations.Location Name',
        defaultMessage: 'Location Name'
    },
    addLocationDetails:{
        id: 'quoteandbind.common.views.locations.AddLocation Details',
        defaultMessage: 'Add Location Details'
    },
    locations:{
        id: 'quoteandbind.common.views.locations.locations',
        defaultMessage: 'Locations'
    },
    locationDetails:{
        id: 'quoteandbind.common.views.locations.LocationDetails',
        defaultMessage: 'Location Details'
    }
});
